export enum TipoCajaTramo {
  CAJA_TRAMO_UNO = 'cajaTramoUno',
  CAJA_TRAMO_DOS = 'cajaTramoDos',
  CAJA_TRAMO_TRES = 'cajaTramoTres',
}
